import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  useStripe,
  useElements,
  CardElement,
} from "@stripe/react-stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  getStripeIntent,
  UI_BASE_URL,
  STRIPE_PUBLISHABLE_KEY,
} from "../../utils/Constants";

const CheckoutForm = ({
  price,
  address,
  name,
  nannyId,
  categoryId,
  date,
  orderId,
  bookingId,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    try {
      const token = localStorage.getItem("Token");
      const headers = {
        Authorization: token,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };

      // 1️⃣ Get PaymentIntent from backend
      const response = await fetch(
        `${BASE_URL}${getStripeIntent}?price=${price}&address=${address}&name=${name}&nannyId=${nannyId}&categoryId=${categoryId}&date=${date}&orderId=${orderId}&bookingId=${bookingId}`,
        {
          method: "GET",
          headers: headers,
        }
      );

      const data = await response.json();
      const clientSecret = data.data.client_secret;
      if (!clientSecret) {
        setErrorMessage("Failed to get PaymentIntent");
        return;
      }

      const cardElement = elements.getElement(CardElement);
      const { error, paymentIntent } = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: name,
              address: { line1: address },
            },
          },
        }
      );

      if (error) {
        setErrorMessage(error.message);
      } else {
        // window.location.href = `${UI_BASE_URL}/payment-success`;
        navigate(`/payment-success?payment_intent=${paymentIntent.id}`);
      }
    } catch (err) {
      console.error("Payment error:", err);
      setErrorMessage("Something went wrong while processing payment.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement
        options={{
          style: {
            base: {
              fontSize: "16px",
              color: "#32325d",
              "::placeholder": { color: "#a0aec0" },
            },
            invalid: { color: "#fa755a" },
          },
        }}
      />
      <div className="pay_button">
        <button type="submit" disabled={!stripe || !elements}>
          Pay
        </button>
      </div>
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
    </form>
  );
};

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const StipePayment = () => {
  const location = useLocation();
  const {
    address,
    date,
    time,
    categoryId,
    price,
    firstName,
    lastName,
    nannyId,
    orderId,
    bookingId,
  } = location.state;

  return (
    <div className="container custom-input" style={{ minHeight: '80vh' }}>
      <div className="stripe_card_center">
        <div
          className="stripe_width"
          style={{
            marginTop: '20vh',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#fff',
            maxWidth: '500px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <h4 style={{ marginBottom: '15px', textAlign: 'center', fontWeight: '600' }}>
            Secure Payment
          </h4>
          <p style={{ textAlign: 'center', marginBottom: '5px', color: '#979393ff', fontSize: '15px' }}>
            Please provide your card details below to complete the booking securely.
            Your payment information is safely handled by Stripe.
          </p>
          <Elements stripe={stripePromise}>
            <CheckoutForm
              price={price}
              address={address}
              name={`${firstName} ${lastName}`}
              nannyId={nannyId}
              date={date}
              categoryId={categoryId}
              orderId={orderId}
              bookingId={bookingId}
            />
          </Elements>
        </div>
      </div>
    </div>
  );

};

export default StipePayment;
